module.exports = __webpack_public_path__ + "static/two-step-verification-3fa6d3ac945de304be41d86053b19ffe.png";